import { CurrencyInput } from '@framework/form';
import type { IWidgetComponentProps } from '~packages/engine/src/schema/widgets/IWidgetType';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { getWidgetProps } from '../common/util/getWidgetProps';
import type { ICurrencyWidget } from './ICurrencyWidget';

export interface ICurrencyWidgetComponentProps
  extends IWidgetComponentProps<ICurrencyWidget> {}

export function CurrencyWidgetComponent(props: ICurrencyWidgetComponentProps) {
  const options = getWidgetProps(props);
  const decimalPlaces = props.widget.decimalSize ?? undefined;

  return (
    <ConfigFormItem
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      <CurrencyInput
        readOnly={props.readonly}
        name={options.name}
        placeholder={options.placeholder}
        value={options.value}
        tabIndex={options.preview ? -1 : undefined}
        decimalPlaces={decimalPlaces}
      />
    </ConfigFormItem>
  );
}
